import { render, staticRenderFns } from "./AreaDetailsView.vue?vue&type=template&id=b526b178"
import script from "./AreaDetailsView.vue?vue&type=script&lang=js"
export * from "./AreaDetailsView.vue?vue&type=script&lang=js"
import style0 from "./AreaDetailsView.vue?vue&type=style&index=0&id=b526b178&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports